import { cssVar, defineStyle, defineStyleConfig } from '@chakra-ui/react'
import { asChakraVariable } from '~/themes/colors/colors'

const $startColor = cssVar('skeleton-start-color')
const $endColor = cssVar('skeleton-end-color')

const mango = defineStyle({
  borderRadius: '0.5rem',
  _light: {
    [$startColor.variable]: asChakraVariable('mask.gray.600.20'),
    [$endColor.variable]: asChakraVariable('mask.gray.600.50'),
  },
  _dark: {
    [$startColor.variable]: asChakraVariable('mask.gray.600.20'),
    [$endColor.variable]: asChakraVariable('mask.gray.600.50'),
  },
})
export const skeletonTheme = defineStyleConfig({
  variants: { mango },
  defaultProps: {
    variant: 'mango',
  },
})
